import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { MainNavSingleItemData } from '../../model/main-nav.model';

@Component({
  selector: 'sh-main-nav-single-item',
  templateUrl: './main-nav-single-item.component.html',
  styleUrl: './main-nav-single-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavSingleItemComponent {
  @Input() item: MainNavSingleItemData | undefined;
  @Output() closeMenu = new EventEmitter();
}
